import { Button, Drawer, Form, Input, Space } from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../../context";

const MerchantEmployeeAddSubExpense = ({
  open,
  close,
  setLoading,
  selectedExpense,
  rerun,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const [form] = Form.useForm();

  const handleAddExpenseSub = (values) => {
    const formdata = new FormData();
    formdata.append(
      "merchant_user_id",
      userData.data.usersmerchantemployee.merchant_user_id
    );
    formdata.append("expense_type_id", selectedExpense);

    for (const name in values) {
      formdata.append(name, values[name]);
    }

    setLoadings(true);
    setLoading(true);
    axios
      .post("user/merchant/create/expense-config-sub", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Expense sub created successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            setLoading(false);
            rerun();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Add Expense Sub"
      // width={500}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Form
        layout="vertical"
        name="create-expense-type"
        initialValues={{
          description: "",
        }}
        onFinish={handleAddExpenseSub}
        autoComplete="off"
        form={form}
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Form.Item
            name="description"
            label="Description"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set description" size="large" />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Create"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default MerchantEmployeeAddSubExpense;
